export default __webpack_public_path__ + "img/c1004.f2f9ebc3.svg";